module.exports = __webpack_public_path__ + "img/200528_ERG-19-2885_Flyer_SBU_Berufsstarter_RZ.0b3bda7d.jpg";